import React, { useState } from 'react'
import Recaptcha from 'react-recaptcha'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const Wrapper = styled.div`
  > form {
    width: 500px;
    max-width: 100%;
  }
`

const Input = styled.input`
  font-family: 'TT Norms Pro';
  color: rgb(255 255 255);
  background: rgb(67 58 94 / 45%);
  border: 1px solid rgb(232 217 255 / 31%);
  text-shadow: 0px 1px 2px #372958db;
  height: 44px;
  width: 100%;
  border-radius: 50px;
  padding-left: 20px;

  &::placeholder {
    color: ${(props) => (props.variant === 'light' ? '#FFFFFF' : 'black')};
    font-family: 'TT Norms Pro';
    font-style: italic;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
  @media (max-width: 600px) {
    ${(props) => props.mb && 'margin-bottom:16px;'}
  }
`

const TextInput = styled.textarea`
  font-family: 'TT Norms Pro';
  color: rgb(255 255 255);
  background: rgb(67 58 94 / 45%);
  border: 1px solid rgb(232 217 255 / 31%);
  text-shadow: 0px 1px 2px #372958db;

  box-sizing: border-box;
  width: 100%;
  border-radius: 20px;
  resize: none;
  padding: 20px 0 20px 20px;

  color: ${(props) => (props.variant === 'light' ? '#FFFFFF' : 'black')};
  &::placeholder {
    color: ${(props) => (props.variant === 'light' ? '#FFFFFF' : 'black')};
    font-family: 'TT Norms Pro';
    font-style: italic;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
  }
`

const TopWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  width: 100%;
  gap: 5px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
  /* border:2px solid yellow; */
`

const SubmitButton = styled.input`
  text-transform: uppercase;
  padding: 0 20px;
  height: 44px;
  border-radius: 50px;
  border: none;
  font-family: 'TT Norms Pro';
  font-size: 14px;
  margin-top: 16px;
  width: 115px;
`

const CaptchaWrapper = styled.div`
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: all 2.5 ease;
  margin-top: 20px;
`

function ContactForm({ variant }) {
  const { t } = useTranslation('')
  const [showSubmitButton, setShowSubmitButton] = useState(true)
  const [showCaptcha, setShowCaptcha] = useState(false)
  const [captchaVerified, setCaptchaVerified] = useState(false)

  const callback = () => {
    // reCaptcha needs this to fix this bug: reCAPTCHA has already been rendered in this element
    // see: https://github.com/appleboy/react-recaptcha/issues/181#issuecomment-280800414
    // console.log('Done!!!!');
  }

  const verifyCallback = (response) => {
    setShowSubmitButton(true)
    setCaptchaVerified(true)
  }

  const handleTyping = (e) => {
    setShowCaptcha(true)
    !captchaVerified && setShowSubmitButton(false)
  }

  const formSubmissionId = () => {
    const formSubmissionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    return formSubmissionId
  }

  return (
    <Wrapper>
      <form
        method="POST"
        name="fa-form-1"
        action="https://webhook.frontapp.com/forms/8100c40ff6a807f00446/ECpqDRRCKg9Wc1QlaxHYsrnb85sVrz9hnrAqzhJrWnHNIWiQYaXFLssQjn_zKvYajUN10YyaZfLx2RCc7Jf_sPbDZx0XP8LXcxywrYf_wxMu9h3pfiJDNZTGfNtETw"
        enctype="multipart/form-data"
        accept-charset="utf-8"
      >
        <TopWrapper>
          <Input
            type="hidden"
            name="form_submission_id"
            value={formSubmissionId()}
          />
          <Input
            mr
            mb
            type="text"
            name="name"
            placeholder={'Name'}
            variant={variant}
            onChange={handleTyping}
          />
          <Input
            type="email"
            name="email"
            placeholder={t('contactFooter.placeholder')}
            variant={variant}
            onChange={handleTyping}
          />
        </TopWrapper>
        <TextInput
          placeholder={t('contactFooter.messagePlaceholder')}
          name="body"
          variant={variant}
          onChange={handleTyping}
        />
        <div id="html_element">
          <SubmitButton
            type="submit"
            value="Send"
            disabled={showSubmitButton ? false : true}
          />
          <CaptchaWrapper show={showCaptcha}>
            <Recaptcha
              sitekey="6LdFc2kkAAAAAAFDgWPPFoPtUSu_OqoREsMp0Wf_"
              render="explicit"
              onloadCallback={callback}
              verifyCallback={verifyCallback}
            />
          </CaptchaWrapper>
        </div>
      </form>
    </Wrapper>
  )
}

export default ContactForm
